import { BreadcrumbItem } from "src/appStore";
import { PageUrl } from "src/routes/PageUrl";

/**
 * Типизированные хлебные крошки
 */
export const mdmBreadcrumbs = (defList: (MdmBrCr | null)[]): BreadcrumbItem[] =>
  defList.filter((it) => !!it).map(defToItem);

type Mbc = {
  disabled?: boolean;
};

type MbcName = {
  type: "Name";
  name: string;
};

type MbcObjAndSpecs = Mbc & { type: "ObjAndSpecs" };
type MbcAdminCatalogs = Mbc & { type: "AdminCatalogs" };
type MbcAdminClassifiers = Mbc & { type: "AdminClassifiers" };
type MbcAdminValueCatalogs = Mbc & { type: "AdminValueCatalogs" };
type MbcAdminPrimSpecs = Mbc & { type: "AdminPrimSpecs" };
type MbcAdminSecondSpecs = Mbc & { type: "AdminSecondSpecs" };
type MbcAdminValueSpecs = Mbc & { type: "AdminValueSpecs" };
type MbcUsersAndRoles = Mbc & { type: "UsersAndRoles" };
type MbcAdminUsers = Mbc & { type: "AdminUsers" };
type MbcAdminRoles = Mbc & { type: "AdminRoles" };
type MbcAdminWorkflows = Mbc & { type: "AdminWorkflows" };
type MbcAdminExtensions = Mbc & { type: "AdminExtensions" };

export type MdmBrCr =
  | MbcAdminCatalogs
  | MbcAdminClassifiers
  | MbcAdminExtensions
  | MbcAdminPrimSpecs
  | MbcAdminRoles
  | MbcAdminSecondSpecs
  | MbcAdminUsers
  | MbcAdminValueCatalogs
  | MbcAdminValueSpecs
  | MbcAdminWorkflows
  | MbcName
  | MbcObjAndSpecs
  | MbcUsersAndRoles;

/* eslint consistent-return: "off" */
/* eslint default-case: "off" */

const defToItem = (def: MdmBrCr): BreadcrumbItem => {
  switch (def.type) {
    case "Name":
      return { title: def.name };
    case "ObjAndSpecs":
      return {
        title: "Объекты и спецификации",
        ...mkRef(def, PageUrl.managementCatalogs),
      };
    case "AdminCatalogs":
      return {
        title: "Каталоги",
        ...mkRef(def, PageUrl.managementCatalogs),
      };
    case "AdminClassifiers":
      return {
        title: "Классификаторы",
        ...mkRef(def, PageUrl.managementClassifiers),
      };
    case "AdminValueCatalogs":
      return {
        title: "Каталоги значений",
        ...mkRef(def, PageUrl.managementValueCatalogs),
      };
    case "AdminPrimSpecs":
      return {
        title: "Первичные спецификации",
        ...mkRef(def, PageUrl.managementPrimSpecs),
      };
    case "AdminSecondSpecs":
      return {
        title: "Вторичные спецификации",
        ...mkRef(def, PageUrl.managementSecondSpecs),
      };
    case "AdminValueSpecs":
      return {
        title: "Спецификации значений",
        ...mkRef(def, PageUrl.managementValueSpecs),
      };
    case "UsersAndRoles":
      return {
        title: "Пользователи и роли",
        ...mkRef(def, PageUrl.managementUsers),
      };
    case "AdminUsers":
      return {
        title: "Пользователи",
        ...mkRef(def, PageUrl.managementUsers),
      };
    case "AdminRoles":
      return {
        title: "Роли",
        ...mkRef(def, PageUrl.managementRoles),
      };
    case "AdminWorkflows":
      return {
        title: "Рабочие потоки",
        ...mkRef(def, PageUrl.managementWorkflows),
      };
    case "AdminExtensions":
      return {
        title: "Расширения",
        ...mkRef(def, PageUrl.managementExtensions),
      };
  }
};

const mkRef = (
  def: Mbc,
  pgUrl: PageUrl,
): Pick<BreadcrumbItem, "page" | "params"> => ({
  page: def?.disabled ? undefined : pgUrl,
});
